import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/auth/(auth)/create-organization')({
  component: CreateOrganizationPage,
})

function CreateOrganizationPage() {
  return <div>Create Organization Page</div>
}
